import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {SolutionService} from '../../../Services/solution.service';

@Component({
  selector: 'app-solution-overview',
  templateUrl: './solution-overview.component.html',
  styleUrls: ['./solution-overview.component.scss']
})
export class SolutionOverviewComponent implements OnInit {

  public grid: Grid;
  public solutionId;
  public solutionName;
  @ViewChild('deleteModal', {static: false}) deleteModal;
  @ViewChild('subjectsTooltip', {static: true}) subjectsTooltip;

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private broadcastService: BroadcastService,
    private solutionService: SolutionService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'admin.general_items.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'admin.solution.overview.active_subjects',
          prop: 'serviceSubjects',
          type: TextColumn.type,
          sortable: true,
          translate: true,
          noTruncate: true,
          valueTemplate: this.subjectsTooltip
        },
        <TextColumn>{
          name: 'admin.general_items.status',
          prop: 'status',
          type: TextColumn.type,
          sortable: true,
          translate: true,
          valueFormatter: row => row ? this.translateService.instant('global.active') : this.translateService.instant('global.inactive')
        },
        <NumberColumn>{
          name: 'global.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.solutionService.setPosition(position, row.id).subscribe((res) => {
              this.broadcastService.broadcast('refreshGrid', 'getSolutions');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('/back-office/service/solution/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/service/solution/' + row.id + '/edit'),
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.solutionId = row.id;
                this.solutionName = row.name.bold();
                this.deleteModal.show();
              },
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.solutionService,
      rememberURL: this.router.url,
      method: 'getSolutions',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
    };
  }

  deleteSolution() {
    this.solutionService.deleteSolution(this.solutionId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getSolutions');
    });
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/service/solution/archive');
  }

}
